import React from "react";
import bacteria from "../assets/updated-image.jpg";
import arrowup from "../assets/arrowblue.png";
import ref from "../assets/ref.webp";
import { symptoms } from "../constant/data";
import CarryingExtraWeight from "./CarryingExtraWeight";
import OverlookedFactor from "./OverlookedFactor";
import NaturalSolution from "./NaturalSolution";
import MetabolicHealth from "./MetabolicHealth";
import IntroducingSlimetics from "./IntroducingSlimetics";
import SlimeticsFreely from "./SlimeticsFreely";
import TrySlimetics from "./TrySlimetics";
import JustAboutYou from "./JustAboutYou";
import Discount from "./discount";

const Blogs = () => {
  return (
    <div className="space-y-10">
     
      <div className="space-y-4">
     
        <p className="md:text-4xl text-2xl">
          <span className="font-bold">{"DISCOVERY:"}</span>{" "}
          {"Doctors Surprised by This Little-Known Gut Link to Stubborn Weight—Here’s What You Can Do About It"}
        </p>

        <p className=" font-bold" style={{ fontSize: "16px" }}>
          <span className="bg-[#ffbf00]">
            {" If you’ve tried diets, exercise"}
          </span>
          {" or supplements and still haven’t seen results—read this now before your metabolism slows down further."}
        </p>

        <div className="flex items-center">
          <span className="text-xl text-yellow-400">⭐⭐⭐⭐⭐</span>
          <span className="ml-2 text-sm text-[#007185]">{"4,215 Ratings"}</span>
        </div>
      </div>

      <div>
        <div className="rounded-lg overflow-hidden mb-4">
          <img
            src={bacteria}
            alt="GUT HEALTHE"
            className="w-full rounded-3xl border border-gray-100 object-contain"
            draggable="false"
          />
        </div>

        <div className="flex items-center mb-4">
          <div className="w-12 h-12 rounded-full overflow-hidden bg-gray-200 mr-3">
            <img
              src={ref}
              alt="Josephine Barker"
              className="w-full h-full object-cover"
              draggable="false"
            />
          </div>
          <div className="text-[#303030] md:text-[18px] text-xs">
            <span>{" By Josephine Barker / Medical Journalist"}</span>
          </div>

          <div className="md:ml-10 ml-auto flex items-center gap-2  px-2 py-1 rounded-full text-xs">
            <div>
              <img
                src="https://img.funnelish.com/19232/185804/1725372175-verified1.jpg"
                alt=""
                className="h-6 w-6 object-contain"
                draggable="false"
              />
            </div>
            <span className="md:text-lg text-xs text-[#303030]">
              {" "}
              <i>{"March 22nd, 2025"} </i>{" "}
            </span>
          </div>
        </div>

        <div className="space-y-4 text-[#303030]">

          <p>
            “We may finally understand why some people find it nearly impossible
            to lose weight,” says Dr. Kandace, a leading metabolic health
            specialist. She recently introduced{" "}
            <span className="font-bold">Slimetics—</span>a gut-focused formula
            that supports metabolic function, digestive health, and weight
            balance naturally.
          </p>

          <p>
            This discovery is turning heads across the wellness world, revealing
            a key reason behind stubborn belly fat—and what you can do to
            support your body’s natural fat-burning process.
          </p>

          <p>
            “I’ve helped more than 3,000 patients take control of their
            digestive and metabolic health,” says Dr. Kandace. “The gut plays a
            bigger role than we ever realized—and now we have a way to support
            it safely and naturally.”
          </p>

          <p>
            With over 15 years in the field, she’s seen a wide range of
            challenges:
          </p>

        </div>
      </div>

      <div className="bg-[#e2f4f9] p-4">
        {symptoms.map((symptom, index) => (
          <div
            key={index}
            className="flex items-center gap-3 mb-4 last:mb-0 text-lg"
          >
            <div className="flex-shrink-0">
              <img
                src={arrowup}
                alt=""
                className="w-10 h-10"
                draggable="false"
              />
            </div>

            <span className="text-[#303030] font-bold">{symptom}</span>
          </div>
        ))}
      </div>
      <p>
        {
          "“When nothing else works—it’s often the gut that needs attention. And that’s where real change begins.”"
        }
      </p>
      <CarryingExtraWeight />
      <OverlookedFactor />
      <NaturalSolution />
      <MetabolicHealth />
      <IntroducingSlimetics />
      <SlimeticsFreely />
      <TrySlimetics />
      {/* <JustAboutYou /> */}
      <Discount />
    </div>
  );
};

export default Blogs;